export const encryptionKeyFixture = 'X'.repeat(32) // 32 bytes
